/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.51   Rana simulation core release: 3.7.3   deployed on:  10:12AM (UTC) on September 07, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { MethodEnum } from "./MethodEnum";
import {
  MethodEnumFromJSON,
  MethodEnumFromJSONTyped,
  MethodEnumToJSON,
  MethodEnumToJSONTyped,
} from "./MethodEnum";
import type { FlowVariableEnum } from "./FlowVariableEnum";
import {
  FlowVariableEnumFromJSON,
  FlowVariableEnumFromJSONTyped,
  FlowVariableEnumToJSON,
  FlowVariableEnumToJSONTyped,
} from "./FlowVariableEnum";

/**
 * A type of `ModelSerializer` that uses
 * hyperlinked relationships with compound keys instead
 * of primary key relationships.  Specifically:
 * * A 'url' field is included instead of the 'id' field.
 * * Relationships to other instances are hyperlinks, instead of primary keys.
 * NOTE: this only works with DRF 3.1.0 and above.
 * @export
 * @interface PatchedAggregationSettings
 */
export interface PatchedAggregationSettings {
  /**
   *
   */
  readonly url?: string;
  /**
   * Give your aggregation setting a name to be able to find it back in the results file.
   */
  name?: string | null;
  /**
   * Options:
   * water_level = Water Level
   * flow_velocity = Flow Velocity
   * discharge = Discharge
   * volume = Volume
   * pump_discharge = Pump Discharge
   * wet_cross_section = Wet Cross Section
   * lateral_discharge = Lateral Discharge
   * wet_surface = Wet Surface
   * rain = Rain
   * simple_infiltration = Simple Infiltration
   * leakage = Leakage
   * interception = Interception
   * surface_source_sink_discharge = Surface Source Sink Discharge
   *
   *
   * * `water_level` - Water Level
   * * `flow_velocity` - Flow Velocity
   * * `discharge` - Discharge
   * * `volume` - Volume
   * * `pump_discharge` - Pump Discharge
   * * `wet_cross_section` - Wet Cross Section
   * * `lateral_discharge` - Lateral Discharge
   * * `wet_surface` - Wet Surface
   * * `rain` - Rain
   * * `simple_infiltration` - Simple Infiltration
   * * `leakage` - Leakage
   * * `interception` - Interception
   * * `surface_source_sink_discharge` - Surface Source Sink Discharge
   */
  flowVariable?: FlowVariableEnum;
  /**
   * Options:
   * min = minimum value of the variable in the configured interval
   * max = maximum value of the variable in the configured interval
   * avg = average value of the variable in the configured interval
   * cum = variable integration over time [dt * variable]
   * cum_positive = variable integration over time [dt * variable] in positive direction
   * cum_negative = variable integration over time [dt * variable] in negative direction
   * current = current value of a variable
   * sum = variable summation over configured interval
   *
   * Note: 'current' is required in case one checks the water balance for variables that are the result of the processes. Only valid for flow_variable 'volume' and 'intercepted_volume'
   *
   * * `min` - minimum value of the variable in the configured interval
   * * `max` - maximum value of the variable in the configured interval
   * * `avg` - average value of the variable in the configured interval
   * * `cum` - variable integration over time [dt * variable]
   * * `cum_positive` - variable integration over time [dt * variable] in positive direction
   * * `cum_negative` - variable integration over time [dt * variable] in negative direction
   * * `current` - current value of a variable
   * * `sum` - variable summation over configured interval
   */
  method?: MethodEnum;
  /**
   * aggregation interval in seconds
   */
  interval?: number;
}

/**
 * Check if a given object implements the PatchedAggregationSettings interface.
 */
export function instanceOfPatchedAggregationSettings(
  value: object
): value is PatchedAggregationSettings {
  return true;
}

export function PatchedAggregationSettingsFromJSON(json: any): PatchedAggregationSettings {
  return PatchedAggregationSettingsFromJSONTyped(json, false);
}

export function PatchedAggregationSettingsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PatchedAggregationSettings {
  if (json == null) {
    return json;
  }
  return {
    url: json["url"] == null ? undefined : json["url"],
    name: json["name"] === undefined ? undefined : json["name"] === null ? null : json["name"],
    flowVariable:
      json["flow_variable"] == null ? undefined : FlowVariableEnumFromJSON(json["flow_variable"]),
    method: json["method"] == null ? undefined : MethodEnumFromJSON(json["method"]),
    interval: json["interval"] == null ? undefined : json["interval"],
  };
}

export function PatchedAggregationSettingsToJSON(json: any): PatchedAggregationSettings {
  return PatchedAggregationSettingsToJSONTyped(json, false);
}

export function PatchedAggregationSettingsToJSONTyped(
  value?: Omit<PatchedAggregationSettings, "url"> | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    name: value["name"],
    flow_variable: FlowVariableEnumToJSON(value["flowVariable"]),
    method: MethodEnumToJSON(value["method"]),
    interval: value["interval"],
  };
}
